export * from './translate.service';
export * from './translations';
export * from './translate.pipe';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/index.ts